import { render, staticRenderFns } from "./SSFormHeader.vue?vue&type=template&id=521c78d2&scoped=true"
import script from "./SSFormHeader.vue?vue&type=script&lang=js"
export * from "./SSFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c78d2",
  null
  
)

export default component.exports